// extracted by mini-css-extract-plugin
export default {"area":"BackDropLoading_area__MV1OD","loader":"BackDropLoading_loader__56Wcq","spin":"BackDropLoading_spin__tBVqw"};